import React, { Component } from "react";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import NavigatorMain from "../NavigatorMain";
import NHeader from "../NHeader.js";
import { getCondition, verifyActivityBool } from "../../action/investmentAction";
import { getPayAllSuper, goLogin } from "../../getPay";
import Position from "../Position";
import ChangeFundListEntry from "../ChangeFundListEntry.js";
import BaseInformationGeneral from "../BaseInformationGeneral";
import SuperFundDetailTab from "../SuperFundDetailTab";
import ModalSelect from "../Modal/ModalSelect";
import { Toast } from "antd-mobile/lib";
import { onMiniProgramDialog } from '../../common.js'
import { getStrategiesDetails, getSuperFundProductIncome, LineDataDelAction, superFundProductIncomeDelAction, strategiesDetailsDel,   lineDataLastDel } from "../../action/portfolioAction";
import { GuidePageType } from "../guidePage/index.js";
import Guide from '../guidePage';
import CacheHOC from "../HOC/StateCache.js"

class SuperFundDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataval: null,
      buyStatus: false,
      planBuyStatus: false,
      superFundCode: "",
      superFundName: "",
      superData: "",
      isInvestmentAdvisory: false
    };
  }
  componentWillMount() {}
  componentDidMount() {
    if(this.props.location.search.indexOf('appInvestmentAdvisory') !== -1){
      this.setState({isInvestmentAdvisory: true})
    }
    document.title = "策略详情";
    this.setState({
      superFundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode,
      superFundName: this.props.location.state ? this.props.location.state.superFundName : this.props.location.query.superFundName,
    });
    let objVal = {
      superFundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode,
      stopProfit: false,
    };
    this.props.dispatch(
      verifyActivityBool(objVal, (result) => {
        this.setState({
          buyStatus: result.buyStatus,
          planBuyStatus: result.planBuyStatus,
        });
        console.log(result);
      })
    );
    this.props.dispatch(
      getStrategiesDetails(
        {
          superFundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode,
        },
        (val) => {
          this.setState({ superData: val });
        }
      )
    );
    const params = {
      superFundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode,
      periodType: 1,
    };
    this.props.dispatch(getSuperFundProductIncome(params));
    document.body.scrollTo(0, 0);
  }
  componentDidUpdate() {}
  componentWillUnmount() {
    Guide.leave();
  }
  async goInvesting() {
    const isMiniProgram = onMiniProgramDialog(GuidePageType.Trade)
    if (isMiniProgram) return
    Toast.loading('',0)
    let route = window.history.length;
    let { dispatch } = this.props;
    let { superFundCode, superFundName } = this.state;
    let data = {
      superFundCode: superFundCode,
    };
    const fun = function () {
      let params = {
        fundCode: superFundCode,
        fundName: superFundName,
        isShowModal: true, //首次购买弹窗标识
        productType: "Z",
        pageText: "申购",
        superTypeValue: "0",
      };
      getPayAllSuper(route, params, hashHistory, "PaymentAllSuperFund");
    };
    goLogin(fun, window.history.length, {isInvestmentAdvisory: this.state.isInvestmentAdvisory,fundCode: superFundCode,fundName: superFundName,enterType: this.props.location.query.enterType});
  }

  goDT = () => {
    const isMiniProgram = onMiniProgramDialog(GuidePageType.Trade)
    if (isMiniProgram) return
    let { dispatch } = this.props;
    let { superFundCode, superFundName } = this.state;
    let params = {
      fundCode: superFundCode,
      fundName: superFundName,
      isShowModal: true, //首次购买弹窗标识
      productType: "Z",
      pageText: "新建定投计划",
      superTypeValue: "0",
    };
    let fun = () => {
      getPayAllSuper(window.history.length, params, hashHistory, "PaymentAllSuperFund");
    };
    goLogin(fun, window.history.length, {isInvestmentAdvisory: this.state.isInvestmentAdvisory,fundCode: superFundCode,fundName: superFundName,enterType: this.props.location.query.enterType});
  };

  render() {
    let { buyStatus, planBuyStatus, superData } = this.state;
    const { dataval, manageFeeRate, minLimit } = this.props;
    const tradeDateString = dataval ? dataval.tradeDateString : "";
    const buyConfirmDate = dataval ? `${dataval.buyConfirmDate.slice(5)}(${dataval.buyConfirmWeek})` : "";
    const buyIncomeDate = dataval ? `${dataval.buyIncomeDate.slice(5)}(${dataval.buyIncomeWeek})` : "";
    return (
      <div className="container">
        <ModalSelect />
        <NavigatorMain>
          <NHeader title="策略详情" isPaddingBottom={0} />
        </NavigatorMain>
        <div className="content" id="SuperFundDetailIndex" style={{ paddingTop: "0px",display:'flex',flex:1,flexDirection:'column',overflowY:'scroll' }}>
          <BaseInformationGeneral superFundCode={this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode} superFundName={this.props.location.state ? this.props.location.state.superFundName : this.props.location.query.superFundName} />
          {this.props.hasOneYear && <SuperFundDetailTab superFundCode={this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode} />}
          <Position />
          <ChangeFundListEntry superFundCode={this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode} />
          <div style={{padding: "0 .1rem" }}>
            <div
              onClick={() => {
                hashHistory.push({
                  pathname: "/JaoYi",
                  state: { dispatch: this.props.dispatch, fundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode },
                });
              }}
              style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", fontSize: "0.3rem", paddingTop: "0.3rem", paddingBottom: "0.3rem" }}
            >
              <div style={{ fontSize: ".32rem", fontWeight: 500, color: "#333" }}>交易规则</div>
              <div style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", color: "#999", fontSize: ".24rem" }}>
                更多
                <img alt="" src={require("../../imgs/youjiantougray@3x.png")} style={{ width: "0.2rem" }} />
              </div>
            </div>
            <div style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", color: "gray", fontSize: "0.2rem" }}>
              <div style={{ textAlign: "center" }}>
                <div style={{ paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem" }}>转入申请</div>
                <img alt="" src={require("../../imgs/sanjiao@3x.png")} style={{ width: "0.2rem", height: "0.2rem" }} />
              </div>
              <div style={{ textAlign: "center" }}>
                <div style={{ paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem" }}>开始确认交易</div>
                <img alt="" src={require("../../imgs/sanjiao@3x.png")} style={{ width: "0.2rem", height: "0.2rem" }} />
              </div>
              <div style={{ textAlign: "center" }}>
                <div style={{ paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem" }}>查看收益</div>
                <img alt="" src={require("../../imgs/sanjiao@3x.png")} style={{ width: "0.2rem", height: "0.2rem" }} />
              </div>
            </div>
            <div style={{ display: "flex", paddingLeft: "0.75rem", paddingRight: "0.75rem", backgroundColor: "#ffffff" }}>
              <div style={{ width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem" }}></div>
              <div style={{ flex: "1", borderBottom: "0.02rem solid #D6DAE4", marginBottom: "0.03rem" }}></div>
              <div style={{ width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem" }}></div>
              <div style={{ flex: "1", borderBottom: "0.02rem solid #D6DAE4", marginBottom: "0.03rem" }}></div>
              <div style={{ width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem" }}></div>
            </div>
            <div style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", fontSize: "0.2rem", color: "#818597" }}>
              <div style={{ flex: 1, textAlign: "left" }}>{tradeDateString}</div>
              <div style={{ flex: 1, textAlign: "center" }}>{buyConfirmDate}</div>
              <div style={{ flex: 1, textAlign: "right" }}>{buyIncomeDate}</div>
            </div>
            <div style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.2rem", paddingBottom: "0.2rem", color: "gray", fontSize: "0.2rem" }}>
              <div style={{ paddingTop: "0.2rem", paddingBottom: "0.2rem", paddingLeft: "0.2rem", border: "0.02rem solid #D6DAE4", color: "#D6DAE4", backgroundColor: "#F6F7FA", flex: 1, borderRadius: "0.1rem" }}>* 实际确认金额和查看盈亏的时间以基金公司为准</div>
            </div>
            <div
              onClick={() => {
                hashHistory.push({
                  pathname: "/FeiL",
                  state: {
                    manageFeeRate: manageFeeRate,
                  },
                });
              }}
              style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", marginTop: "0.2rem", fontSize: "0.2rem" }}
            >
              <div style={{ paddingTop: "0.3rem", flex: "1", fontSize: ".32rem", fontWeight: 500, color: "#333" }}>费用说明</div>
              <div style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", color: "#999", fontSize: ".24rem", paddingTop: "0.3rem" }}>
                更多
                <img alt="" src={require("../../imgs/youjiantougray@3x.png")} style={{ width: "0.2rem" }} />
              </div>
            </div>
            <div style={{ color: "#333", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", fontSize: "0.28rem", lineHeight: "0.4rem" }}>
              <div style={{ paddingTop: "0.3rem" }}>
                1、投顾服务费：本组合以客户账户资产净值<span style={{ color: "#BF9B79" }}>{manageFeeRate || "--"}</span>（年化）计提投资顾问服务费。每日计提，月度结算。
              </div>
              <div style={{ paddingTop: "0.3rem", paddingBottom: "0.3rem" }}>
                2、申购费与赎回费：本组合<span style={{ color: "#BF9B79" }}>不重复收取申购、赎回费用</span>。成分基金申购费用0至1折，成分基金赎回费用按照基金招募说明书收取。
              </div>
            </div>
            <div
              onClick={() => {
                let code = superData.superFundPolicy ? (superData.superFundPolicy.policy ? superData.superFundPolicy.policy : "") : "";
                hashHistory.push({
                  pathname: "/WebView",
                  state: { name: superData.superFundPolicy ? (superData.superFundPolicy.policyTitle ? superData.superFundPolicy.policyTitle : "") : "", code: code },
                  query: { code: code },
                });
              }}
              style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", marginTop: "0.2rem", fontSize: "0.3rem", paddingTop: "0.2rem", paddingBottom: "0.2rem" }}
            >
              <div style={{ fontSize: ".32rem", fontWeight: 500, color: "#333" }}>策略说明书</div>
              <div style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", color: "#999", fontSize: ".24rem" }}>
                查看
                <img alt="" src={require("../../imgs/youjiantougray@3x.png")} style={{ width: "0.2rem" }} />
              </div>
            </div>
            <div style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", marginTop: "0.2rem", fontSize: "0.3rem" }}>
              <div style={{ paddingTop: "0.3rem", flex: "1", fontSize: ".32rem", fontWeight: 500, color: "#333" }}>常见问题</div>
            </div>

            <div style={{ color: "#333", display: "flex", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.3rem", backgroundColor: "#ffffff" }}>
              <div style={{ width: "0.5rem", height: "0.5rem", position: "relative" }}>
                <img alt="" src={require("../../imgs/changjianwentiQ@3x.png")} style={{ width: "0.4rem", height: "0.4rem" }} />
                <div style={{ position: "absolute", top: "0.05rem", left: "0.07rem", color: "#ffffff", fontSize: "0.2rem" }}>Q1</div>
              </div>
              <div style={{ flex: 1, display: "flex", fontSize: "0.2rem", paddingTop: "0.04rem", fontSize: "0.28rem" }}>什么是查理智投？</div>
            </div>
            <div style={{ color: "#333", display: "flex", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", backgroundColor: "#ffffff" }}>
              <div style={{ width: "0.5rem", height: "0.5rem", position: "relative" }}>
                <img alt="" src={require("../../imgs/changjianxiangqingA@3x.png")} style={{ width: "0.4rem", height: "0.4rem" }} />
                <div style={{ position: "absolute", top: "0.05rem", left: "0.07rem", color: "#ffffff", fontSize: "0.2rem" }}>A1</div>
              </div>
              <div style={{ flex: 1, display: "flex", fontSize: "0.2rem", paddingTop: "0.04rem", lineHeight: "0.4rem", fontSize: "0.28rem" }}>查理智投是华夏基金借助大数据手段，利用人工智能技术，借助算法和模型为投资者制定的理财方案。查理智投力求为不同人生阶段、不同风险收益偏好的投资者提供个性化的投顾服务。</div>
            </div>
            <div style={{ color: "#333", display: "flex", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.3rem", backgroundColor: "#ffffff" }}>
              <div style={{ width: "0.5rem", height: "0.5rem", position: "relative" }}>
                <img alt="" src={require("../../imgs/changjianwentiQ@3x.png")} style={{ width: "0.4rem", height: "0.4rem" }} />
                <div style={{ position: "absolute", top: "0.05rem", left: "0.07rem", color: "#ffffff", fontSize: "0.2rem" }}>Q2</div>
              </div>
              <div style={{ flex: 1, display: "flex", fontSize: "0.2rem", paddingTop: "0.04rem", fontSize: "0.28rem" }}>基金投顾和基金组合有什么区别？</div>
            </div>
            <div style={{ color: "#333", display: "flex", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", backgroundColor: "#ffffff", paddingBottom: "0.2rem" }}>
              <div style={{ width: "0.5rem", height: "0.5rem", position: "relative" }}>
                <img alt="" src={require("../../imgs/changjianxiangqingA@3x.png")} style={{ width: "0.4rem", height: "0.4rem" }} />
                <div style={{ position: "absolute", top: "0.05rem", left: "0.07rem", color: "#ffffff", fontSize: "0.2rem" }}>A2</div>
              </div>
              <div style={{ flex: 1, display: "flex", fontSize: "0.2rem", paddingTop: "0.04rem", lineHeight: "0.4rem", fontSize: "0.28rem" }}>相对于组合来说，基金投顾是专业投顾团队根据用户风险等级和投资需求定制化选基，并提供自动调仓，陪伴服务等一站式资产配置服务。</div>
            </div>
            {/* <div style={{WebkitFlexDirection:"row", display:"-webkit-flex", WebkitJustifyContent:"space-between", WebkitAlignItems:"center",backgroundColor:"#ffffff",paddingLeft:"0.3rem",paddingRight:"0.3rem",marginTop:"0.3rem",fontSize:"0.3rem"}}>
                <div style={{paddingBottom:"0.3rem",paddingTop:"0.3rem",flex:"1"}}>
                  风险提示：
                </div>
              </div> */}
            <div style={{ lineHeight: "0.4rem", color: "#5A5A62", fontSize: "0.2rem", marginBottom: "0.8rem", paddingLeft: "0.2rem", paddingRight: "0.2rem", paddingBottom: "0.7rem", marginTop: "0.2rem" }}>风险提示：市场有风险，投资需谨慎。本公司承诺以诚实信用、勤勉尽责的原则提供基金投资顾问服务，提供投资建议并为投资者调仓，但不保证投顾账户一定盈利，也不保证最低收益。组合历史业绩不代表未来收益。本公司提醒投资者接受基金投资顾问服务遵循“买者自负”原则，投资者应结合自身的投资经历、风险承受能力、资产配置需要作出投资决策，投顾账户的投资风险由投资者自行承担。为其他客户创造的收益，并不构成业绩表现的保证。基金投资组合策略的风险特征与单只基金产品的风险特征存在差异。投资者应自行阅读《上海华夏财富投资管理有限公司基金投资顾问服务协议》《风险揭示书》《组合策略说明书》等产品法律文件，自行做出投资选择。基金投顾组合及基金投资遵循“买者自负”原则，投资者应自行承担投资风险。</div>
          </div>
        </div>
        {buyStatus || planBuyStatus ? (
          <div style={{ paddingTop: "0.12rem", paddingBottom: "0.14rem", color: "#333", display: "flex", justifyContent: "center", backgroundColor: "gray", position: "fixed", bottom: "40px", width: "100%", backgroundColor: "#F6F1E9", fontSize: ".24rem" ,zIndex:'9999999'}}>
            {minLimit != null ? minLimit : "--"}元起，投顾费率：{manageFeeRate != null ? manageFeeRate : "--"}
          </div>
        ) : null}

        <div className="FixedBottomNot">
          {/* <div onClick={this.goMath}>
              <div className="jsqi"></div>
              <div style={{ color:"#5c6270", fontSize:'10px'}}>养老规划</div>
            </div> */}
          {planBuyStatus ? (
            <div onClick={this.goDT}>
              <div style={{ color: "#B69271", fontSize: "0.26rem" }}>定投</div>
            </div>
          ) : null}
          {buyStatus ? (
            <div onClick={() => this.goInvesting()} style={{ backgroundColor: "#BF9B79", color: "#ffffff", fontSize: "0.26rem" }}>
              转入
            </div>
          ) : (
            <div onClick={() => {}} style={{ backgroundColor: "#C4C4C4", color: "#ffffff", fontSize: "0.26rem" }}>
              已暂停转入
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { problemList = {}, superFundBasicInfo = {}, superFundAdjustmentVersion = {}, superFundConfirmAndIncomeDate, superFundManageRate = {}, superFundTradeLimit = {} } = state.strategiesDetails;
  return {
    SupperFundHome: state.SupperFundHome,
    fullOneYear: superFundBasicInfo.fullOneYear,
    effectDateStr: superFundAdjustmentVersion && superFundAdjustmentVersion.effectDateStr,
    dataval: superFundConfirmAndIncomeDate,
    manageFeeRate: superFundManageRate.manageFeeRate,
    minLimit: superFundTradeLimit.minLimit,
    hasOneYear: state.superFundProductIncomes.hasOneYear
  };
}
export default connect(mapStateToProps)(CacheHOC(SuperFundDetail,'SuperFundDetailIndex'));



// WEBPACK FOOTER //
// ./src/components/fundDetail/SuperFundDetail.js